export const systemDashboardIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The System Dashboard is where you can view key overview data on student usage and progress.'
  },
    {
    element: 'refresh-button',
    intro: 'Click here to refresh the Dashboard data.'
  },
  {
    element: '.teacher-dashboard-box.students-enrolled',
    intro: 'See the total number of students currently enrolled in the WordFlight System. Click here to go to your Student List.'
  },
  {
    element: '.teacher-dashboard-box.students-not-started',
    intro: 'See the total number of students who have not begun using the WordFlight System yet. Click here to see a full list of students with no logins.'
  },
  {
    element: '.teacher-dashboard-box.weekly-time-goal',
    intro: 'See the percentage of students who met their weekly time goal in the previous week. Click here to see a full list of your students and their weekly usage minutes for the previous week.'
  },
  {
    element: '.teacher-dashboard-box.average-weekly-usage',
    intro: 'See the average weekly usage time for all students, both all-time and for the previous week.'
  },
  {
    element: '.teacher-dashboard-box-long.total-points',
    intro: 'See the total points earned by all students using WordFlight. Click here to go to the Group Summary report.'
  },
  {
    element: '.teacher-dashboard-box-long.weekly-tip',
    intro: 'Find helpful tips each week to maximize your students\' experience with WordFlight.'
  },
  {
    element: '.dashboard-graph-label',
    intro: 'See the number of students working in each unit in the WordFlight System.'
  },
];